/*
 * Бейдж незавершённой возможности. Значения — docs/reference/phase-2-mockup.md §3
 * («Бейдж roadmap»), снятые с макета: строка «Тариф» в деталях брони (prototype:1491 — сама строка
 * у нас снята 29.08, замер остался) и карточка
 * вложения в ленте (там же). Оба образца в макете совпадают до пикселя, кроме кегля — 8.5px у
 * «не работает» и 8px у «не реализовано»; берём 8.5, разница в полпикселя между двумя копиями
 * одного элемента это дрейф макета, а не дизайн (тот же случай, что у ленты чата — §4 справочника).
 *
 * `--st-pending` во ВСЕХ трёх ролях («не реализовано» / «скоро» / «не работает»): в макете
 * покрашены обе встреченные копии, и разного цвета по видам бейджа там нет.
 *
 * ТЕКСТ — `--ink`, и это ПРАВИЛО 2 МАКЕТА v5, а не наша самодеятельность: цветной текст на
 * заливке из того же цвета не берёт AA по построению — заливка разбавляется подложкой и светлеет,
 * текст остаётся насыщенным, обе стороны пары сходятся. Этот бейдж давал 2.72 : 1 при норме 4.5 —
 * ХУДШИЙ контраст во всём приложении; с `--ink` он даёт 15.04. В макете так покрашены все
 * двенадцать копий бейджа (`color:var(--ink)` на `color-mix(…var(--st-pending) 15%…)`).
 *
 * Оранжевыми остались ЗАЛИВКА и КАЙМА — «недоделано» читается по ним, а не по цвету букв.
 */
.root {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  padding: 1px 6px;
  border: 1px solid color-mix(in oklch, var(--st-pending) 32%, transparent);
  border-radius: 999px;
  background: color-mix(in oklch, var(--st-pending) 15%, var(--tint-on));
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 8.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--ink);
  white-space: nowrap;
}
